import React from 'react';

export const ChevronIcon = ({ open }) => (
  <svg
    className={`coupon-chevron ${open ? 'open' : ''}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2256 16.3779C19.9328 16.6708 19.4579 16.6708 19.165 16.3779L12.0005 9.2134L4.83599 16.3779C4.5431 16.6708 4.06823 16.6708 3.77533 16.3779C3.48244 16.085 3.48244 15.6101 3.77533 15.3172L12.0005 7.09208L20.2256 15.3172C20.5185 15.6101 20.5185 16.085 20.2256 16.3779Z"
      fill="#373737"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Chevron.icon.jsx